import { BriefDataType } from './MediaFactors';
import { MediaFactorType } from './useOptions';
import useSWR from 'swr';
import { BriefChannel, BriefTaskChannel, BriefTaskChannelData, MediaObject } from '../../../../api/types';
import urls from '../../../../api/urls';
import { api } from '../../../../api/apiProvider';
import { useEffect, useState } from 'react';

export interface BriefTaskType {
  briefChannels: string[];
  briefTaskChannelData: BriefTaskChannelData[];
  commentary: string;
  file: MediaObject | null;
  id: number;
  key: string;
  manager: string;
  media: string | null;
  name: string;
  product: string | undefined;
  source: string;
  status: string | null;
  taskDataId: number | null;
}

export default function useBriefTasks (type: MediaFactorType, brief: BriefDataType) {
  const [tasks, setTasks] = useState<BriefTaskType[]>([]);
  const [fileList, setFileList] = useState<Record<number, boolean>>([]);

  const {
    data: briefTasks,
    mutate: refreshBriefTasks,
  } = useSWR<{
    data: BriefTaskChannel[]
  }>(
    brief ? `${urls.briefTaskChannels}?briefChannels.brief.id=${brief.id
    }&t[]=briefChannel&t[]=dict&t[]=taskChannelData&t[]=media_object:read&briefChannels.channel.media.code=${type}` : null,
    api.get,
    {
      revalidateOnFocus: false,
    });

  useEffect(() => {
    if (briefTasks && briefTasks.data) {
      const newTasks = briefTasks.data.map((briefTask: BriefTaskChannel) => ({
        id: briefTask.id,
        name: briefTask.name,
        product: briefTask.product?.['@id'],
        media: briefTask.media?.['@id'],
        briefChannels: briefTask.briefChannels.map((briefChannel: BriefChannel) => briefChannel['@id']),
        briefTaskChannelData: briefTask.briefTaskChannelData,
        manager: briefTask.manager,
        source: '',
        commentary: briefTask.commentary,
        key: String(briefTask.id),
        taskDataId: briefTask.briefTaskChannelData && briefTask.briefTaskChannelData[0]
          && briefTask.briefTaskChannelData[0].id || null,
        file: briefTask.briefTaskChannelData && briefTask.briefTaskChannelData[0]
        && briefTask.briefTaskChannelData[0].file ? briefTask.briefTaskChannelData[0].file : null,
        status: briefTask.briefTaskChannelData && briefTask.briefTaskChannelData[0]
        && briefTask.briefTaskChannelData[0].status ? briefTask.briefTaskChannelData[0].status : null,
      }));

      const files: Record<number, boolean> = [];
      for (let key in briefTasks.data) {
        const briefTaskKpi = briefTasks.data[key];
        if (!briefTaskKpi.briefTaskChannelData) {
          continue;
        }
        for (let taskData of briefTaskKpi.briefTaskChannelData) {
          if (taskData.file) {
            files[key] = true;
          }
        }
      }

      setFileList(files);
      setTasks(newTasks);
    }
  }, [briefTasks]);

  return {
    tasks,
    refreshBriefTasks,
    fileList,
    setFileList,
  }
}
